import ServerApi from './$server.api'

export default {
    getWalletUser
}

async function getWalletUser(userId) {
    return await ServerApi.request('get', `/wallets/user/${ userId }`)
}